<template>
  <div class="item">
    <DirectorySingleJournalist v-if="isJournalist" :item="this.item"></DirectorySingleJournalist>
    <DirectorySinglePartner v-else-if="isPartner" :item="this.item"></DirectorySinglePartner>
  </div>
</template>

<script>
import DirectorySingleJournalist from "@/components/DirectorySingleJournalist";
import DirectorySinglePartner from "@/components/DirectorySinglePartner";

export default {
  name: 'DirectorySingleItem',
  components: {DirectorySinglePartner, DirectorySingleJournalist},
  props: {
    item: Object
  },

  computed: {
    isPartner() {
      if (!this.item.type) {
        return false;
      }

      return this.item.type.toLowerCase() === 'partenaire';
    },

    isJournalist() {
      if (!this.item.type) {
        return false;
      }

      return this.item.type.toLowerCase().trim() === 'journaliste';
    },

    getLocation() {
      return [this.item.adresse, this.item.cp, this.item.ville].filter(Boolean).join(', ');
    },
  }
}
</script>

<style scoped>
.item {
  animation: fadeIn ease 1s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
